import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';
import * as DateHelpers from './DateHelpers';

interface MissingScheduleItemProps {
    systemCompanyId: number;
    scheduleDate: string;
    doUpdate: boolean;
    scheduleBranchId: number;
    show: boolean;
    hide(): void;
    save(missingItemCount: number, onHoldItemCount: number): void;
}

interface MissingHoldScheduleItem {
    jobId: number;
    siteAddress: string;
    isEvent: boolean;
    customer: string;
    jobQuoteItemId: number;
    itemId: number;
    item: string;
    quantity: number;
    quantityType: string;
    notes: string;
    pickupDate: string;
    selected: boolean;
}

const MissingScheduleItemData = (props: MissingScheduleItemProps) => {
    const [scheduleDate, setScheduleDate] = React.useState(DateHelpers.getCurrentDate());
    const [missingItems, setMissingItems] = React.useState<MissingHoldScheduleItem[]>([]);
    const [onHoldItems, setOnHoldItems] = React.useState<MissingHoldScheduleItem[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});

    React.useEffect(() => {
        if (props.show) {
            var formatDate = DateHelpers.formatDate(props.scheduleDate);
            setScheduleDate(formatDate);
            if (props.systemCompanyId === 3) {
                getData();
            }
        }
    }, [props.doUpdate]);

    const getData = async () => {
        const token = await authService.getAccessToken();

        axios.get('api/Allocate/GetMissingHoldJobs', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                for (var i = 0; i < errors.length; i++) {
                    toast.error(errors[i].content);
                };
            } else {
                setMissingItems(res.data.missingItems);
                setOnHoldItems(res.data.onHoldItems);
                setLoading(false);
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const selectItem = (e: any, index: number) => {
        var results = [...missingItems];
        var result = results[index];
        result.selected = e.target.checked;
        setMissingItems(results);
    }

    const onItemPickupChange = (e: any, index: number) => {
        var results = [...missingItems];
        var result = results[index];
        result.pickupDate = e.target.value;
        setMissingItems(results);
    }

    const selectHoldItem = (e: any, index: number) => {
        var results = [...onHoldItems];
        var result = results[index];
        result.selected = e.target.checked;
        setOnHoldItems(results);
    }

    const onHoldPickupChange = (e: any, index: number) => {
        var results = [...onHoldItems];
        var result = results[index];
        result.pickupDate = e.target.value;
        setOnHoldItems(results);
    }

    const hideModal = () => {
        props.hide();
    }

    const validate = () => {
        let formIsValid = true;
        let errorList: any = {};
        var rowNumber = 0
        var error = false;
        var selectedItems = missingItems.filter(m => m.selected);
       
        var errorString = "Please enter the following values: ";
        for (var i = 0; i < selectedItems.length; i++) {
            rowNumber += 1;
            var newErrorString = "";
            var item = selectedItems[i];

            if (item.isEvent && !DateHelpers.isValidDate(item.pickupDate)) {
                newErrorString += " Valid Pickup Date, ";
                error = true;
            }
            if (newErrorString != "") {
                errorString += "\n";
                errorString += "Row " + rowNumber + ": " + newErrorString;
                errorString = errorString.substring(0, errorString.length - 2);
            }
        }
        if (error) {
            formIsValid = false;
            errorList["missingItems"] = errorString;
        }

        var selectedHoldItems = onHoldItems.filter(h => h.selected);
        rowNumber = 0
        error = false;
        var errorHoldString = "Please enter the following values: ";
        for (var i = 0; i < selectedHoldItems.length; i++) {
            rowNumber += 1;
            var newErrorString = "";
            var item = selectedHoldItems[i];

            if (item.isEvent && !item.pickupDate) {
                newErrorString += " Pickup Date, ";
                error = true;
            } else if (item.isEvent && !DateHelpers.isValidDate(item.pickupDate)) {
                newErrorString += " Valid Pickup Date, ";
                error = true;
            }
            if (newErrorString != "") {
                errorHoldString += "\n";
                errorHoldString += "Row " + rowNumber + ": " + newErrorString;
                errorHoldString = errorHoldString.substring(0, errorHoldString.length - 2);
            }
        }
        if (error) {
            formIsValid = false;
            errorList["holdItems"] = errorHoldString;
        }

        setErrors(errorList);
        return formIsValid;
    }

    const schedule = (e: any) => {
        e.preventDefault();

        var selectedItems = missingItems.filter(m => m.selected);
        var selectedHoldItems = onHoldItems.filter(h => h.selected);
        if (selectedItems.length === 0 && selectedHoldItems.length === 0) {
            toast.error("Select at least one item to schedule!");
        } else {
            if (validate()) {
                scheduleJobs(selectedItems, selectedHoldItems);
            } else {
                toast.error("Fix errors on screen before scheduling!");
            }
        }
    }

    const scheduleJobs = async (missingJobs: MissingHoldScheduleItem[], onHoldJobs: MissingHoldScheduleItem[]) => {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var saveMissingItems = {
            scheduleDate: props.scheduleDate,
            scheduleBranchId: props.scheduleBranchId,
            subId: user.sub,
            jobs: missingJobs,
            onHoldJobs: onHoldJobs
        };

        //update list to remove the ones we just filtered
        var missJobs = [...missingItems].filter(m => !m.selected);
        var holdJobs = [...onHoldItems].filter(h => !h.selected);

        axios.post('api/Allocate/SaveMissingHoldItems', saveMissingItems, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            setMissingItems(missJobs);
            setOnHoldItems(holdJobs);
            props.save(missJobs.length, holdJobs.length);
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div className="static-modal">
            <Modal size="xl" show={props.show} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Schedule Job/s for {scheduleDate}</Modal.Title>
                    <button type="button" className="close" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <h1>Missing Jobs</h1>
                        <div className='overflowAuto allocate-missinghold--height'>
                            <table className='table tableColours'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Job Id</th>
                                        <th>Site Address</th>
                                        <th>Customer</th>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                        <th>Pickup</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {missingItems.map((result, index) =>
                                        <tr key={index}>
                                            <td><input type='checkbox' className="input" checked={result.selected} onChange={(e) => selectItem(e, index)} /></td>
                                            <td>
                                                <Link to={'/job/' + result.jobId} target="_blank" >
                                                    {result.jobId}
                                                </Link>
                                            </td>
                                            <td>
                                                <div className="tooltipitem  tooltipitem__right">{result.siteAddress ? result.siteAddress.substring(0, 30) + "... " : ""}
                                                    <span className="tooltipitemtext  tooltipitemtext__right">{result.siteAddress}</span>
                                                </div>
                                            </td>
                                            <td>{result.customer}</td>
                                            <td>{result.item}</td>
                                            <td>{result.quantityType}</td>
                                            <td>
                                                <input type={result.isEvent ? "date" : "hidden"} className="form-control allocate__dateSize" value={result.pickupDate} onChange={(e) => onItemPickupChange(e, index)} />
                                            </td>
                                            <td>
                                                <div className="tooltipitem  tooltipitem__left">{result.notes ? result.notes.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext  tooltipitemtext__left">{result.notes}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {errors["missingItems"] ?
                                (errors["missingItems"]).split("\n").map((item: any, key: any) => {
                                    return <span className="label errors" key={key}>{item}<br /></span>
                                })
                                : ""}
                        </div>
                        <h1>On Hold Jobs </h1>
                        <div className='overflowAuto allocate-missinghold--height'>
                            <table className='table tableColours'>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Job Id</th>
                                        <th>Site Address</th>
                                        <th>Customer</th>
                                        <th>Item</th>
                                        <th>Quantity</th>
                                        <th>Pickup</th>
                                        <th>Notes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {onHoldItems.map((result, index) =>
                                        <tr key={index}>
                                            <td><input type='checkbox' className="input" checked={result.selected} onChange={(e) => selectHoldItem(e, index)} /></td>
                                            <td>
                                                <Link to={'/job/' + result.jobId} target="_blank" >
                                                    {result.jobId}
                                                </Link>
                                            </td>
                                            <td>
                                                <div className="tooltipitem  tooltipitem__right">{result.siteAddress ? result.siteAddress.substring(0, 30) + "... " : ""}
                                                    <span className="tooltipitemtext  tooltipitemtext__right">{result.siteAddress}</span>
                                                </div>
                                            </td>
                                            <td>{result.customer}</td>
                                            <td>{result.item}</td>
                                            <td>{result.quantityType}</td>
                                            <td>
                                                <input type={result.isEvent ? "date" : "hidden"} className="form-control allocate__dateSize" value={result.pickupDate} onChange={(e) => onHoldPickupChange(e, index)} />
                                            </td>
                                            <td>
                                                <div className="tooltipitem  tooltipitem__left">{result.notes ? result.notes.substring(0, 20) + "... " : ""}
                                                    <span className="tooltipitemtext  tooltipitemtext__left">{result.notes}</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            {errors["holdItems"] ?
                                (errors["holdItems"]).split("\n").map((item: any, key: any) => {
                                    return <span className="label errors" key={key}>{item}<br /></span>
                                })
                                : ""}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={schedule}>Schedule</button>
                </Modal.Footer>
            </Modal>
        </div>
    );

    let contents = loading
        ? ""
        : renderDetails;

    return (<div>
        {contents}
    </div>)
}

export default MissingScheduleItemData;